import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import PartNumber from 'shared/components/parameters/PartNumber';
import Revision from 'shared/components/parameters/Revision';
import EmailAddress from 'shared/components/parameters/EmailAddress';
import GerberFile from 'taiwan_pcb/project/ZipFile';

import { changeGlobalParameter } from 'shared/product_tabs/tab_project/actions/changeGlobalParameter';

import { validatorProject as validator } from 'taiwan_pcb/pcb_fabrication/slice/validators';
import { selectFabricationParameters, selectFabricationValidatorFlag } from 'taiwan_pcb/pcb_fabrication/slice/selectors';
import { changeParameter } from 'taiwan_pcb/pcb_fabrication/slice/fabricationSlice';

const Project = () => {
  const dispatch = useDispatch();
  const parameters = useSelector(selectFabricationParameters);

  // eslint-disable-next-line no-unused-vars
  const validatorFlag = useSelector(selectFabricationValidatorFlag);

  const onChangeParameter = (name, value) => {
    dispatch(changeParameter({ name, value }));
    dispatch(changeGlobalParameter({ name, value }));
  };

  const props = {
    parameters,
    onChangeParameter,
  };

  return (
    <div className="container">
      <div className="row">
        <div className="col-12 col-sm-6 col-lg-2">
          <PartNumber
            {...props}
            errorMessage={validator.message('Part Number', parameters.part_number, 'required|min:3')} />
        </div>
        <div className="col-12 col-sm-6 col-lg-2">
          <Revision {...props} />
        </div>
        <div className="col-12 col-sm-6 col-lg-2">
          <EmailAddress
            {...props}
            errorMessage={validator.message('Email Address', parameters.email_address, 'required|email')} />
        </div>
        <div className="col-12 col-sm-6 col-lg-2">
          <GerberFile
            {...props}
            label="Upload Zip File"
            text="Browse"
            validator={validator} />
        </div>
      </div>
    </div>
  );
};

export default Project;
